import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    border: 0,
    height: "40vh",
    width: "100%",
    borderRadius: 4,
  },
}));
